var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beef-tooltip"},[_c('h1',[_vm._v("Private "+_vm._s(_vm.network)+" mentions")]),_c('p',[_c('strong',[_c('deq-number',{attrs:{"number":_vm.privateCount}})],1),_vm._v(" of these mentions were private ")])])}
var staticRenderFns = []

export { render, staticRenderFns }